'use strict';

const { find } = require('underscore');

const BaseView = require('./base');

const { any } = require('underscore');

class PickersView extends BaseView {
  initialize() {
    this.on('renderComplete', this.postRender);
    this.setModule('glive_booking_redesign');
  }

  add({ view, model, collection, selectionName, handleSelect }) {
    if (this.pickers == null) {
      this.pickers = [];
    }

    const picker = new view({
      model,
      collection: model.get(collection),
      previous: this.pickers[this.pickers.length - 1],
      selectionName,
    });

    picker.on('select', selection => {
      handleSelect(selection);

      this.pickers.forEach(selectPicker => selectPicker.autoSelect());

      const nextPicker = this.nextUnselectedPicker();

      if (nextPicker) {
        this.collapse(true);
        this.expand(nextPicker);
      } else {
        this.trigger('collapse');
        picker.once('collapsed', () => this.trigger('collapsed'));
        this.collapse(false);
      }
    });

    picker.on('expand', newPicker => {
      if (this.picker) {
        this.collapse(true);
      }

      this.setActivePicker(newPicker);
    });

    picker.on('collapse', this.unsetActivePicker, this);

    this.pickers.push(picker);

    return picker;
  }

  expanded() {
    return any(this.pickers, picker => picker.isVisible);
  }

  render() {
    super.render(...arguments);

    this.pickers.forEach(picker => {
      this.$el.append(picker.render().el);
    });

    this.trigger('renderComplete');
    return this;
  }

  postRender() {
    const picker = this.nextUnselectedPicker();
    if (picker) {
      this.expand(picker);
    }
  }

  expand(picker) {
    picker.show();
    picker.once('expanded', () => this.trigger('expanded'));
  }

  nextUnselectedPicker() {
    return find(this.pickers, picker => !picker.getSelection());
  }

  collapse() {
    return this.picker.hide(true);
  }

  setActivePicker(picker) {
    if (picker) {
      this.picker = picker;
    }
    return picker;
  }

  unsetActivePicker() {
    return delete this.picker;
  }
}

module.exports = PickersView;
